import Chart from './chart/Main.vue'
import GoogleMapLoader from './google-map-loader/Main.vue'
import Highlight from './highlight/Main.vue'
import Litepicker from './litepicker/Main.vue'
import Tippy from './tippy/Main.vue'
import TippyContent from './tippy-content/Main.vue'
import TomSelect from './tom-select/Main.vue'
import LoadingIcon from './loading-icon/Main.vue'
import TinySlider from './tiny-slider/Main.vue'
import ClassicEditor from './ckeditor/ClassicEditor.vue'
import Dropzone from './dropzone/Main.vue'
import FullCalendar from './calendar/Main.vue'
import FullCalendarDraggable from './calendar/Draggable.vue'
import Datepicker from 'vue3-date-time-picker'
import 'vue3-date-time-picker/dist/main.css'

import Loading from './loading/Main.vue'
import VueAxios from 'vue-axios'
import axios from 'axios'
import Toaster from '@meforma/vue-toaster'
import VueGoogleMaps from '@fawmi/vue-google-maps'
import CurrencyInput from './currency-input/Main.vue'

import * as featherIcons from '@zhuowenli/vue-feather-icons'

/**
  App global custom components
*/

export default (app) => {
  app.component('Chart', Chart)
  app.component('GoogleMapLoader', GoogleMapLoader)
  app.component('Highlight', Highlight)
  app.component('Litepicker', Litepicker)
  app.component('Tippy', Tippy)
  app.component('TippyContent', TippyContent)
  app.component('TomSelect', TomSelect)
  app.component('LoadingIcon', LoadingIcon)
  app.component('TinySlider', TinySlider)
  app.component('Dropzone', Dropzone)
  app.component('ClassicEditor', ClassicEditor)
  app.component('FullCalendar', FullCalendar)
  app.component('FullCalendarDraggable', FullCalendarDraggable)

  app.component('Loading', Loading)
  app.component('CurrencyInput', CurrencyInput)
  app.component('Datepicker', Datepicker)

  axios.defaults.baseURL = process.env.VUE_APP_BASE_API_URL
  axios.defaults.headers.common['Content-Type'] = 'application/json'
  axios.defaults.headers.common.Accept = 'application/json'

  app.use(VueAxios, axios)
  app.use(Toaster)
  app.use(VueGoogleMaps, {
    load: {
      key: process.env.VUE_APP_BASE_GOOGLE_API_KEY,
      libraries: 'places',
      region: 'MX',
      language: 'es'
    }
  })

  for (const [key, icon] of Object.entries(featherIcons)) {
    icon.props.size.default = '24'
    app.component(key, icon)
  }
}
